module.exports = __webpack_public_path__ + "media/4.01f7e3d2.mp3";